export default __webpack_public_path__ + "static/sprite-3e9ec46f2b0b02981a6db8d15cc2a2aa.svg";